import { dataBackground } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBackground = /*#__PURE__*/createIcon(dataBackground)
export default IconBackground
